import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { query, where, collection, onSnapshot, getDocs } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx";
import { MdArrowBackIos, MdClose, MdDelete } from "react-icons/md";
import Update_staff_account from "./update_staff_account.jsx";
import Ledger_accounts_profile from "./ledger_accounts_profile.jsx"; 

export default function Staff_accounts_edit() {
    const servicetablename = "companies";
    const navigate = useNavigate();
    const location = useLocation();
    const [voucherid, setVoucherid] = useState("");
    const [IsLoading2, setIsLoading2] = useState(true);
    const [ledger_accountsdata, setLedger_accountsdata] = useState([]);
    const [accountguid, setaccountguid] = useState();
    const [manage_ledger_accountsdata, setManage_ledger_accountsdata] = useState([]);
    const { Toastshow } = Toast();
    const [manageaccountguid, setManageaccountguid] = useState();
    const [voucher, setVoucher] = useState("");
    const [vouchersdata, setVouchersdata] = useState([]);
    const [voucher_type, setVoucher_type] = useState(0);
    // Read accountguid from navigation state ONLY once
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);

        const accountguids =
            location.state?.accountguid ||
            queryParams.get("accountguid");

        if (!accountguids || accountguids === "null") {
            // Toastshow("Invalid account number: " + accountguid);
            return;
        }

        setaccountguid(accountguids);
        setManageaccountguid(accountguids);
    }, [location]);

    // Load ledger account
    useEffect(() => {
        if (!accountguid) return;

        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) {
            Toastshow("Company not selected");
            return;
        }
        setIsLoading2(true);
        const productQuery = query(
            collection(db, servicetablename, select_company_uid, "staff_accounts"),
            where("accountguid", "==", accountguid)
        );

        const unsubscribe = onSnapshot(
            productQuery,
            (snapshot) => {
                const data = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setLedger_accountsdata(data);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Fetch error:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    }, [accountguid]);
    // Fetch Ledger Accounts

    // useEffect(() => {
    //     const fetch_manage_ledger_accounts = () => {
    //         if (!accountguid) return;
    //         const select_company_uid = Cookies.get("select_company_uid");
    //         if (!select_company_uid) return;

    //         setIsLoading2(true);

    //         const q = query(
    //             collection(db, servicetablename, select_company_uid, "ledger_accounts_manager"),
    //             where("accountguid", "==", accountguid)
    //         );

    //         const unsubscribe = onSnapshot(
    //             q,
    //             (snapshot) => {
    //                 const rows = snapshot.docs.map((docSnap) => ({
    //                     id: docSnap.id,
    //                     ...docSnap.data(),
    //                 }));

    //                 setManage_ledger_accountsdata(rows);
    //                 setIsLoading2(false);
    //             },
    //             (error) => {
    //                 console.error("Error fetching ledger accounts:", error);
    //                 setIsLoading2(false);
    //             }
    //         );

    //         return unsubscribe;
    //     };

    //     const unsubscribe = fetch_manage_ledger_accounts();

    //     // Cleanup listener when accountguid changes or component unmounts
    //     return () => {
    //         if (unsubscribe) unsubscribe();
    //     };
    // }, [accountguid]);

    // useEffect(() => {
    //     const fetc_hvouchers_info = async () => {
    //         if (!voucherid) return;

    //         const select_company_uid = Cookies.get("select_company_uid");
    //         if (!select_company_uid) return;

    //         setIsLoading2(true);

    //         // Correct path: companies/{company_uid}/vouchers
    //         const productQuery = query(
    //             collection(db, servicetablename, select_company_uid, "vouchers"),
    //             where("voucherid", "==", voucherid)
    //             //  orderBy("indexnumber", "asc")
    //         );

    //         const unsubscribe = onSnapshot(
    //             productQuery,
    //             (snapshot) => {
    //                 const vouchers = snapshot.docs.map((docSnap) => ({
    //                     id: docSnap.id,
    //                     ...docSnap.data(),
    //                 }));

    //                 const v = vouchers[0] || {};

    //                 setVoucher_type(v.voucher_type);
    //                 setVoucher(v.voucher || "");

    //                 setIsLoading2(false);
    //             },
    //             (error) => {
    //                 console.error("Error fetching vouchers:", error);
    //                 setIsLoading2(false);
    //             }
    //         );

    //         return () => unsubscribe();
    //     };
    //     fetc_hvouchers_info();
    // }, [voucherid]);
    //
    // const fetchvouchers = async () => {


    //     const select_company_uid = Cookies.get("select_company_uid");
    //     if (!select_company_uid) return;

    //     setIsLoading2(true);

    //     // Correct path: companies/{company_uid}/vouchers
    //     const productQuery = query(
    //         collection(db, servicetablename, select_company_uid, "vouchers"),
    //         //   where("voucherid", "==", voucherid)
    //         //  orderBy("indexnumber", "asc")
    //     );

    //     const unsubscribe = onSnapshot(
    //         productQuery,
    //         (snapshot) => {
    //             const vouchers = snapshot.docs.map((docSnap) => ({
    //                 id: docSnap.id,
    //                 ...docSnap.data(),
    //             }));

    //             setVouchersdata(vouchers);
    //             setIsLoading2(false);
    //         },
    //         (error) => {
    //             console.error("Error fetching vouchers:", error);
    //             setIsLoading2(false);
    //         }
    //     );

    //     return () => unsubscribe();
    // };
    // useEffect(() => {
    //     fetchvouchers();
    // }, [accountguid]); 

 
    return (
        <div>
            <div className="b-bottom">
                <table>
                    <tr>
                        <td ><div
                            onClick={() => navigate(navigate(-1))}
                            className="button-ui0 text-h2 bold p-2 cursor">
                            <MdArrowBackIos className="icon" />Account edit
                        </div></td>
                        <td width={30}>
                            <div
                               onClick={() => navigate("/accounting?page=company")}
                                className="button-ui0 p-2 cursor"
                            >
                                <MdClose className="icon" />
                            </div>
                        </td>
                    </tr>
                </table>
            </div>

            <div className="post-container p-2">
                <div className="post_updates b-1 rounded p-11">
                    <div className="ui-grid-home-items ">
                        {IsLoading2 ? (
                            <></>
                        ) : ledger_accountsdata.length === 0 ? (
                            <div className="text-h2 bold p-5">No account found</div>
                        ) : (
                            ledger_accountsdata.map((row) => (
                                <div
                                    className="ui-items m-1 items-back  "
                                    key={row.id}
                                >

                                    <table className="b-bottom">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div
                                                        className="button-ui0 bold"
                                                        style={{
                                                            color: row.status ? "green" : "red",
                                                        }}
                                                    >
                                                        {row.status ? "Activate" : "Deactivate"}
                                                    </div>
                                                </td>
                                                <td width={150} className="text-h3 text-r">
                                                    {row.date_time?.toDate ? (
                                                        <>
                                                            {row.date_time
                                                                .toDate()
                                                                .toLocaleDateString()}{" "}
                                                            {row.date_time
                                                                .toDate()
                                                                .toLocaleTimeString()}
                                                        </>
                                                    ) : (
                                                        <div className="contact-details">No date</div>
                                                    )}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                 
                                    <Ledger_accounts_profile accountguid={row.accountguid} />
                                       <div className="fill p-2 text-h3">Reg id: {row.accountguid}</div>
                                    <Update_staff_account data={row} />  
                                </div>
                            ))
                        )}
                    </div>

                </div>

                <div className="post_div">
 
                </div>
            </div>
        </div>
    );
}
